module.exports = __webpack_public_path__ + "static/media/ellipsisbox-focused.bf7233e3.svg";